<template>
  <div class="menu-management">
    <div class="operation-bar">
      <el-button type="primary" size="mini" @click="handleAddModule">创建模块</el-button>
      <el-button type="danger" size="mini" :disabled="!selectedRows.length" @click="handleBatchDelete"
        >批量删除</el-button
      >
    </div>

    <el-table
      :data="tableData"
      border
      row-key="id"
      :tree-props="{ children: 'children' }"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="name" label="模块名称" width="240"></el-table-column>
      <el-table-column prop="code" label="模块代码" width="180"></el-table-column>
      <el-table-column prop="location" label="位置"></el-table-column>
      <el-table-column prop="path" label="路径"></el-table-column>
      <el-table-column prop="id" label="动作" width="90">
        <template slot-scope="scope">
          <el-tag
            :key="tag.id"
            v-for="tag in scope.row.actions"
            closable
            size="mini"
            :disable-transitions="false"
            @close="handleClose(tag, scope.row)"
            @click="handleTag(tag, scope.row)"
            style="margin-right: 5px"
          >
            {{ tag.name }}
          </el-tag>

          <el-button type="text" @click.stop="handleAdd(scope.row)">添加</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" style="color: #2680dd" @click.stop="handleEditModule(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #f56c6c" @click.stop="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="父级" prop="parentId">
          <el-select v-model="formData.parentId" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in parentOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="模块代码" prop="code">
          <el-input v-model="formData.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="位置" prop="location">
          <el-input v-model="formData.location" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="路径" prop="path">
          <el-input v-model="formData.path" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="是否隐藏菜单" prop="hideMenu">
          <el-radio-group v-model="formData.hideMenu">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否头部导航" prop="headNavigation">
          <el-radio-group v-model="formData.headNavigation">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否快捷入口" prop="expressEntrance">
          <el-radio-group v-model="formData.expressEntrance">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="formData.sort"
            :min="0"
            :precision="0"
            controls-position="right"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 新增动作弹窗 -->
    <el-dialog :title="actionDialogTitle" :visible.sync="actionDialogVisible" width="500px">
      <el-form :model="actionForm" :rules="actionRules" ref="actionFormRef" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="actionForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="操作代码" prop="code">
          <el-input v-model="actionForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="路径" prop="path">
          <el-input v-model="actionForm.path" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="actionForm.description" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="actionDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleActionSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';

export default {
  name: 'MenuManagement',
  data() {
    return {
      tableData: [],
      selectedRows: [],
      dialogVisible: false,
      dialogTitle: '',
      formData: {
        parentId: '',
        name: '',
        code: '',
        location: '',
        path: '',
        hideMenu: false,
        headNavigation: false,
        expressEntrance: false,
        sort: 0,
      },
      parentOptions: [],
      rules: {
        name: [{ required: true, message: '请输入模块名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入模块代码', trigger: 'blur' }],
        location: [{ required: true, message: '请输入位置', trigger: 'blur' }],
        path: [{ required: true, message: '请输入路径', trigger: 'blur' }],
      },

      // 动作相关数据
      actionDialogTitle: '新增动作', // 动作弹窗标题
      actionDialogVisible: false,
      currentRow: null, // 当前操作的行数据
      actionForm: {
        id: '', // 添加id字段用于编辑
        name: '',
        code: '',
        path: '',
        description: '',
        parentId: '',
      },
      actionRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入操作代码', trigger: 'blur' }],
        path: [{ required: true, message: '请输入路径', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取列表数据
    async fetchData() {
      try {
        const res = await axios.post(baseUrl + '/api/sys/menu/modules/tree');
        if (res.code === 200 && res.data) {
          this.tableData = res.data;
          this.updateParentOptions(res.data);
        }
      } catch (error) {}
    },
    // 递归构建父级选项
    updateParentOptions(data, parentPath = '') {
      this.parentOptions = [{ value: '', label: '顶级模块' }];
      const buildOptions = (items, path = '') => {
        items.forEach((item) => {
          const currentPath = path ? `${path} / ${item.name}` : item.name;
          this.parentOptions.push({
            value: item.id,
            label: currentPath,
          });
          if (item.children && item.children.length) {
            buildOptions(item.children, currentPath);
          }
        });
      };
      buildOptions(data);
    },
    // 删除菜单
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该模块吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });

        const res = await axios.post(baseUrl + '/api/sys/menu/remove', { id: row.id });
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
        }
      } catch (error) {
        if (error !== 'cancel') {
        }
      }
    },
    // 批量删除
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个模块吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });

        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(baseUrl + '/api/sys/menu/modules/removeBatch', ids);

        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
        }
      } catch (error) {
        if (error !== 'cancel') {
        }
      }
    },
    // 提交表单
    async handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            const url = this.formData.id ? '/api/sys/menu/modules/update' : '/api/sys/menu/modules/save';
            const res = await axios.post(baseUrl + url, this.formData);
            if (res.code === 200) {
              this.$message.success(this.dialogTitle === '创建模块' ? '创建成功' : '更新成功');
              this.dialogVisible = false;
              this.fetchData();
            } else {
            }
          } catch (error) {}
        }
      });
    },
    // 其他方法保持不变...
    handleClose(tag, row) {
      console.log(tag, row);
    },
    handleTag(tag, row) {
      console.log(tag, row);
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    // 点击添加动作按钮
    handleAdd(row) {
      this.actionDialogTitle = '新增动作';
      this.actionDialogVisible = true;
      this.currentRow = row;
      this.$nextTick(() => {
        this.$refs.actionFormRef.resetFields();
        this.actionForm = {
          id: '',
          name: '',
          code: '',
          path: '',
          description: '',
          parentId: row.id,
        };
      });
    },

    // 提交动作表单（新增或编辑）
    async handleActionSubmit() {
      this.$refs.actionFormRef.validate(async (valid) => {
        if (valid) {
          try {
            const url = this.actionForm.id ? '/api/sys/menu/action/update' : '/api/sys/menu/action/save';

            const res = await axios.post(baseUrl + url, this.actionForm);
            if (res.code === 200) {
              this.$message.success(this.actionForm.id ? '编辑成功' : '添加成功');
              this.actionDialogVisible = false;
              this.fetchData();
            } else {
            }
          } catch (error) {}
        }
      });
    },

    // 点击动作标签进行编辑
    handleTag(tag, row) {
      this.actionDialogTitle = '编辑动作';
      this.actionDialogVisible = true;
      this.currentRow = row;
      this.$nextTick(() => {
        this.actionForm = {
          id: tag.id,
          name: tag.name,
          code: tag.code,
          path: tag.path,
          description: tag.description || '',
          parentId: row.id,
        };
      });
    },

    // 删除动作
    async handleClose(tag, row) {
      try {
        await this.$confirm('确认删除该动作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });

        const res = await axios.post(baseUrl + '/api/sys/menu/action/remove', { id: tag.id });
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
        }
      } catch (error) {
        if (error !== 'cancel') {
        }
      }
    },

    // 重命名原handleAdd方法为handleAddModule
    handleAddModule() {
      this.dialogTitle = '创建模块';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef.resetFields();
        Object.keys(this.formData).forEach((key) => {
          if (typeof this.formData[key] === 'boolean') {
            this.formData[key] = false;
          } else if (typeof this.formData[key] === 'number') {
            this.formData[key] = 0;
          } else {
            this.formData[key] = '';
          }
        });
      });
    },

    // 重命名原handleEdit方法为handleEditModule
    handleEditModule(row) {
      this.dialogTitle = '编辑模块';
      this.dialogVisible = true;
      this.$nextTick(() => {
        Object.keys(this.formData).forEach((key) => {
          this.formData[key] = row[key];
          this.formData.id = row.id;
        });
      });
    },

    // 行点击事件
    handleRowClick(row) {
      this.handleAdd(row);
    },
  },
};
</script>

<style scoped lang="less">
.menu-management {
  padding: 20px;
}

.operation-bar {
  margin-bottom: 20px;
}

.delete-button {
  color: #f56c6c;
}
</style>
